var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        lazy: "",
        persistent: "",
        "full-width": !_vm.isMobile,
        "max-width": "600"
      },
      on: {
        input: function(v) {
          return v
        }
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-toolbar",
            { attrs: { card: "" } },
            [
              _c("v-toolbar-title", { attrs: { flat: "" } }, [
                _vm._v("Repeat a Customer Load")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                { attrs: { avatar: "" } },
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("verified_user")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.sponsor))]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "accent",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_upward")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { staticClass: "pl-2" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          value: _vm.origin,
                          label: "From (Origin Address)"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "accent",
                            small: "",
                            "text-color": "white"
                          }
                        },
                        [_c("v-icon", [_vm._v("play_for_work")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { staticClass: "pl-2" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          value: _vm.destination,
                          label: "To (Destination Address)"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("h2", [_vm._v("New Load Details:")]),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pl-2 pr-2 mt-2",
                      attrs: { color: "primary" }
                    },
                    [_vm._v("event")]
                  ),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: {
                      "input-id": "copyPickupTimePicker",
                      placeholder: "Next Pickup Date"
                    },
                    model: {
                      value: _vm.copyPickupTime,
                      callback: function($$v) {
                        _vm.copyPickupTime = $$v
                      },
                      expression: "copyPickupTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-icon",
                    { staticClass: "pl-2 pr-2", attrs: { color: "primary" } },
                    [_vm._v("local_shipping")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-truck-counter-field",
                    {
                      staticClass: "mt-2",
                      attrs: { rightLabel: "trucks needed", min: 1 },
                      model: {
                        value: _vm.copyLoadCount,
                        callback: function($$v) {
                          _vm.copyLoadCount = $$v
                        },
                        expression: "copyLoadCount"
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { slot: "increment" }, slot: "increment" },
                        [_vm._v("add")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        { attrs: { slot: "decrement" }, slot: "decrement" },
                        [_vm._v("remove")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c("v-textarea", {
                    staticClass: "mt-2",
                    attrs: { rows: 2, label: "Dispatcher instructions" },
                    model: {
                      value: _vm.copyDispatcherInstructions,
                      callback: function($$v) {
                        _vm.copyDispatcherInstructions = $$v
                      },
                      expression: "copyDispatcherInstructions"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c("v-textarea", {
                    staticClass: "mt-2",
                    attrs: { rows: 2, label: "Driver instructions" },
                    model: {
                      value: _vm.copyDriverInstructions,
                      callback: function($$v) {
                        _vm.copyDriverInstructions = $$v
                      },
                      expression: "copyDriverInstructions"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "accent",
                    loading: _vm.loadingBtn,
                    disabled: !_vm.validPickupDate
                  },
                  on: {
                    click: function($event) {
                      return _vm.createLoadFromTemplate()
                    }
                  }
                },
                [_vm._v("\n        Confirm\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "accent", flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v("\n        Cancel\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-353445c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353445c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepeatLoadGroupDialog.vue
// module id = null
// module chunks = 